import { Button, Card, Group, Stack } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import type { FormEvent, ReactNode } from 'react';

interface OnboardingSectionProps {
  title: string;
  children: ReactNode;
  onSave?: () => void | Promise<void>;
  saveLabel?: string;
  isSaving?: boolean;
  saveDisabled?: boolean;
}

export function OnboardingSection({
  title,
  children,
  onSave,
  saveLabel = 'Save',
  isSaving = false,
  saveDisabled = false,
}: OnboardingSectionProps): JSX.Element {
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    void onSave?.();
  };

  return (
    <Card
      shadow="sm"
      padding="lg"
      radius="md"
      withBorder
      style={{ backgroundColor: 'var(--unify-bg-paper)', borderColor: 'var(--mantine-color-gray-5)' }}
    >
      <Stack gap="lg">
        <Group gap="sm">
          <Button
            type="button"
            variant="subtle"
            size="sm"
            leftSection={<IconArrowLeft size={16} />}
            onClick={() => navigate('/onboarding')}
          >
            Back to checklist
          </Button>
        </Group>
        <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 600 }}>{title}</h1>
        {onSave ? (
          <form onSubmit={handleSubmit}>
            <Stack gap="lg">
              {children}
              <Group>
                <Button type="submit" loading={isSaving} disabled={saveDisabled}>
                  {saveLabel}
                </Button>
              </Group>
            </Stack>
          </form>
        ) : children}
      </Stack>
    </Card>
  );
}
